import createStoreFromReducer from 'js/lib/create-store-from-reducer';

import type { SubmissionSchema } from 'bundles/assess-common/types/NaptimeSubmissionSchema';
import { ActionNames } from 'bundles/peer/actions/constants';
import type { Assignment } from 'bundles/peer/types/Assignment';
import { convertSubmissionSchema } from 'bundles/peer/utils/convertLegacyPeerToNaptime';

type LoadingState = 'loading' | 'loaded';

type State = {
  assignment?: Assignment | null;
  naptimeSubmissionSchema?: SubmissionSchema | null;
  loadedItemId?: string | null;
  loadState: LoadingState;
};

export type PeerAssignmentStore = {
  getState(): State;
};

const initialState: State = {
  loadState: 'loading' as LoadingState,
  loadedItemId: undefined,
  assignment: undefined,
  naptimeSubmissionSchema: undefined,
};

function peerAssignment(
  state: State = initialState,
  action: {
    type: typeof ActionNames.LOADING_PEER_ASSIGNMENT | typeof ActionNames.LOADED_PEER_ASSIGNMENT;
    assignment: Assignment;
    loadedItemId: string;
  }
) {
  switch (action.type) {
    case ActionNames.LOADING_PEER_ASSIGNMENT:
      return {
        ...initialState,
      };
    case ActionNames.LOADED_PEER_ASSIGNMENT:
      return {
        ...state,
        assignment: action.assignment,
        naptimeSubmissionSchema: convertSubmissionSchema(action.assignment.submissionSchema),
        loadedItemId: action.loadedItemId,
        loadState: 'loaded' as LoadingState,
      };
    default:
      return state;
  }
}

/**
 * -- Generated using Cursor --
 * Fluxible ReducerStore instance for managing peer assignment state.
 *
 * This store holds the current peer assignment, its loading state, and the associated submission schema.
 * It responds to LOADING_PEER_ASSIGNMENT and LOADED_PEER_ASSIGNMENT actions to update its state.
 *
 * @type {new (dispatcher: Dispatcher) => ReducerStore<State>}
 * @see State for the shape of the store's state
 * @see ActionNames for supported actions
 * @see createStoreFromReducer for implementation details
 */
export const store = createStoreFromReducer<State, Parameters<typeof peerAssignment>[1]>(
  peerAssignment,
  'PeerAssignmentStore',
  [ActionNames.LOADED_PEER_ASSIGNMENT, ActionNames.LOADING_PEER_ASSIGNMENT],
  initialState
);

export const reducer = peerAssignment;
